export interface IPriceChartRequest {
    address: string; //POOL ADDRESS
    network: "ton"; //always TON
    res: ChartResolution;
    from: number; //timestamp
    to: number; //timestamp
}

export interface IPriceChartResponse {
    s: string; // status
    t: number[]; // timestamps
    o: number[]; // open prices
    h: number[]; // high prices
    l: number[]; // low prices
    c: number[]; // close prices
    v: number[]; // volume
}

export interface ICandlestickData {
    time: number;
    open: number;
    high: number;
    low: number;
    close: number;
}

export enum ChartResolution {
    ONE_MINUTE = "1",
    THREE_MINUTES = "3",
    FIVE_MINUTES = "5",
    FIFTEEN_MINUTES = "15",
    THIRTY_MINUTES = "30",
    FORTY_FIVE_MINUTES = "45",
    ONE_HOUR = "1H",
    TWO_HOURS = "2H",
    FOUR_HOURS = "4H",
    SIX_HOURS = "6H",
    TWELVE_HOURS = "12H",
    ONE_DAY = "1D",
    ONE_WEEK = "1W",
    ONE_MONTH = "1M",
}

export class AviproductionChartApi {
    private static basePath = "https://api.aviproduction.org/api/v1/dex";

    public static async getPairPriceChart(req: IPriceChartRequest): Promise<ICandlestickData[] | null> {
        let urlString = `${AviproductionChartApi.basePath}/price-charts`;
        let url = new URL(urlString);

        url.searchParams.append("address", req.address);
        url.searchParams.append("network", req.network);
        url.searchParams.append("res", req.res);
        url.searchParams.append("from", req.from.toString());
        url.searchParams.append("to", req.to.toString());

        try {
            const resp = await fetch(url);
            const data = await resp.json();

            if (data && data.s === "ok") {
                // Transform the response data to ICandlestickData format
                return data.t.map((timestamp: number, index: number) => ({
                    time: timestamp,
                    open: data.o[index],
                    high: data.h[index],
                    low: data.l[index],
                    close: data.c[index],
                }));
            }
            return null;
        } catch (error) {
            return null;
        }
    }
}
